import { api_without_cancellation } from "../../../../../api/api";

const PAGE_SIZE = 25;

// Map tab keys to API type values
const TAB_TO_API_TYPE = {
  all: "all",
  chat: "chat",
  text: "text",
  email: "email",
  letter: "letter",
  phone_call: "phone_call",
};

class ClientUnifiedCommunicationService {
  // Legacy fetch for backwards compatibility
  async fetch(clientId, caseId, token) {
    try {
      const response = await api_without_cancellation.get(
        `/api/client-page/client_communications/${clientId}/${caseId}/`,
        {
          headers: { Authorization: token },
        }
      );

      return { data: response.data, error: null };
    } catch (error) {
      return {
        data: null,
        error: error.response?.data?.message || "Failed to fetch client communications",
      };
    }
  }

  // New paginated fetch by type
  // direction: "older" (default, next page) or "newer" (previous page)
  async fetchByType(clientId, caseId, token, type = "all", cursor = null, direction = null) {
    try {
      const apiType = TAB_TO_API_TYPE[type] || "all";
      const params = new URLSearchParams({
        type: apiType,
        page_size: PAGE_SIZE.toString(),
      });

      if (cursor) {
        params.append("cursor", cursor);
      }

      if (direction === "newer") {
        params.append("direction", "newer");
      }

      const response = await api_without_cancellation.get(
        `/api/client-page/client_communications/${clientId}/${caseId}/?${params.toString()}`,
        {
          headers: { Authorization: token },
        }
      );

      return { data: response.data, error: null };
    } catch (error) {
      return {
        data: null,
        error: error.response?.data?.message || "Failed to fetch communications",
      };
    }
  }

  normalize(data) {
    if (!data?.results) {
      return { all: [], chat: [], text: [], email: [], letter: [], phone: [], call: [] };
    }

    const results = data.results;
    const all = results;
    const chat = results.filter((i) => i.type === "ChatMessage");
    const text = results.filter(
      (i) => i.type === "TextMessage" || i.type === "IncomingTextMessage"
    );
    const email = results.filter((i) => i.type === "Email" || i.comm_type === "Email");
    const letter = results.filter((i) => i.type === "LetterTemplateLog");
    const phone = results.filter((i) => i.type === "PhoneCall");
    const call = results.filter(
      (i) => i.type === "OutboundRecordedCall" || i.type === "InboundRecordedCall"
    );

    return { all, chat, text, email, letter, phone, call };
  }

  // Normalize paginated response results
  normalizeResults(results, _type) {
    if (!results) return [];
    return results;
  }
}

export default new ClientUnifiedCommunicationService();
